











import IconBase from "@/common/components/atoms/IconBase.vue";
import IconCartPath from "@/common/components/icons/IconCartPath.vue";
import { Vue, Component, Prop } from "vue-property-decorator";
@Component({
  components: {
    IconBase,
    IconCartPath
  }
})
export default class IconCart extends Vue {
  @Prop({ type: [Number, String], required: true, default: 48 })
  iconSize!: string;
  @Prop({ type: String, default: "#333333" }) iconColor!: string;
}
